import { c as _slicedToArray, a as _toConsumableArray, _ as _objectSpread2, f as _asyncToGenerator } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useState } from 'react';
import { useResponsiveParams, useQuantaFormikContext, Text, Button, QuantaForm, MixedGridGroup, NotificationList } from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner, faExclamationTriangle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { C as CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, V as VERIFY_CRN_NUMBER, P as PINCODE_LOOKUP, a as CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL } from './queries-9ae26450.js';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import { useQuery } from '@apollo/client';
import 'react-helmet';
import 'react-router-dom';
import './queries-3df8abcc.js';
import { L as Loading } from './loading-c16d3bd3.js';
import './queries-a3e6305b.js';
import moment from 'moment';

function IndividualCustomerForm(_ref) {
  var _reactiveVarData$prop, _reactiveVarData$prop2, _reactiveVarData$prop3, _reactiveVarData$prop4, _reactiveVarData$prop5, _reactiveVarData$prop6, _reactiveVarData$prop9, _reactiveVarData$prop10, _reactiveVarData$prop11, _reactiveVarData$prop12, _sessionStorage, _sessionStorage$getIt, _sessionStorage$getIt2, _sessionStorage2, _sessionStorage2$getI, _sessionStorage2$getI2, _sessionStorage3, _sessionStorage3$getI, _sessionStorage3$getI2, _sessionStorage4, _sessionStorage4$getI, _sessionStorage4$getI2, _reactiveVarData$prop13, _reactiveVarData$prop15, _salutationList$filte, _salutationList$filte2, _reactiveVarData$prop16, _reactiveVarData$prop17, _reactiveVarData$prop18, _reactiveVarData$prop19, _reactiveVarData$prop20, _reactiveVarData$prop21, _reactiveVarData$prop22, _reactiveVarData$prop23, _reactiveVarData$prop24, _reactiveVarData$prop25, _reactiveVarData$prop26, _reactiveVarData$prop27, _reactiveVarData$prop28, _reactiveVarData$prop29, _reactiveVarData$prop30, _reactiveVarData$prop31, _reactiveVarData$prop32, _reactiveVarData$prop33, _values$proposerDetai37, _values$proposerDetai38, _values$proposerDetai39, _values$proposerDetai40, _reactiveVarData$prop34, _reactiveVarData$quot, _reactiveVarData$quot2, _reactiveVarData$prop35, _ref5, _reactiveVarData$prop36, _reactiveVarData$prop37, _reactiveVarData$prop38, _reactiveVarData$prop39, _values$proposerDetai41, _values$proposerDetai42, _reactiveVarData$prop40, _reactiveVarData$prop41, _reactiveVarData$prop42, _values$proposerDetai43, _values$proposerDetai44, _reactiveVarData$prop43, _reactiveVarData$prop44, _reactiveVarData$prop45, _reactiveVarData$prop46, _reactiveVarData$prop47, _reactiveVarData$prop48, _reactiveVarData$prop49, _reactiveVarData$prop50, _reactiveVarData$prop51, _reactiveVarData$prop52, _reactiveVarData$prop53, _reactiveVarData$prop54, _reactiveVarData$prop55, _reactiveVarData$prop56, _reactiveVarData$prop57, _reactiveVarData$prop58, _reactiveVarData$prop59, _reactiveVarData$prop60, _reactiveVarData$prop61, _reactiveVarData$prop62, _reactiveVarData$prop63, _reactiveVarData$prop64, _reactiveVarData$prop65, _reactiveVarData$prop66, _reactiveVarData$prop67, _reactiveVarData$prop68, _reactiveVarData$prop69;

  var setIndvCustomerDomainArr = _ref.setIndvCustomerDomainArr,
      reactiveVarData = _ref.reactiveVarData,
      preGender = _ref.preGender,
      isConfigImd = _ref.isConfigImd;
  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values,
      setFieldValue = _useQuantaFormikConte.setFieldValue;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      alerts = _useState2[0],
      setAlerts = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loadingPermCustAddr = _useState4[0],
      setLoadingPermCustAddr = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loadingCommCustAddr = _useState6[0],
      setLoadingCommCustAddr = _useState6[1];

  var _useState7 = useState((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop === void 0 ? void 0 : _reactiveVarData$prop.isCRNVerified) === "" ? null : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop2 = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop2 === void 0 ? void 0 : _reactiveVarData$prop2.isCRNVerified),
      _useState8 = _slicedToArray(_useState7, 2),
      CRNVerified = _useState8[0],
      setCRNVerified = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loadingVerifyCRN = _useState10[0],
      setLoadingCRN = _useState10[1];

  var _useState11 = useState((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop3 = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop3 === void 0 ? void 0 : (_reactiveVarData$prop4 = _reactiveVarData$prop3.ciuType) === null || _reactiveVarData$prop4 === void 0 ? void 0 : _reactiveVarData$prop4.toString()) === 'Kotak Bank CRN Number' ? true : (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop5 = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop5 === void 0 ? void 0 : (_reactiveVarData$prop6 = _reactiveVarData$prop5.ciuType) === null || _reactiveVarData$prop6 === void 0 ? void 0 : _reactiveVarData$prop6.toString()) == '' ? true : false),
      _useState12 = _slicedToArray(_useState11, 2),
      KotakBankCrnSelected = _useState12[0],
      setKotakBankCrnSelected = _useState12[1];

  var reformData = function reformData(val, returnType) {
    return val && val.toString().trim() !== '' ? val : returnType;
  };

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      var _d$, _d$$toString, _searchText$toString;

      return ((_d$ = d["".concat(searchType)]) === null || _d$ === void 0 ? void 0 : (_d$$toString = _d$.toString()) === null || _d$$toString === void 0 ? void 0 : _d$$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString = searchText.toString()) === null || _searchText$toString === void 0 ? void 0 : _searchText$toString.toLowerCase());
    }) ? domainArr.find(function (d) {
      var _d$2, _d$2$toString, _searchText$toString2;

      return ((_d$2 = d["".concat(searchType)]) === null || _d$2 === void 0 ? void 0 : (_d$2$toString = _d$2.toString()) === null || _d$2$toString === void 0 ? void 0 : _d$2$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString2 = searchText.toString()) === null || _searchText$toString2 === void 0 ? void 0 : _searchText$toString2.toLowerCase());
    })["".concat(returnType)] : '';
  };

  var fetchQuery = useFetchQuery();

  var _useQuery = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: function onCompleted(data) {
      var _values$proposerDetai, _values$proposerDetai2, _values$proposerDetai3;

      setIndvCustomerDomainArr(data);

      if (preGender && !(values !== null && values !== void 0 && (_values$proposerDetai = values.proposerDetails) !== null && _values$proposerDetai !== void 0 && _values$proposerDetai.gender)) {
        var _data$genderList, _data$genderList$find;

        setFieldValue("proposerDetails.gender", data === null || data === void 0 ? void 0 : (_data$genderList = data.genderList) === null || _data$genderList === void 0 ? void 0 : (_data$genderList$find = _data$genderList.find(function (gender) {
          var _gender$code;

          return (gender === null || gender === void 0 ? void 0 : (_gender$code = gender.code) === null || _gender$code === void 0 ? void 0 : _gender$code.toLowerCase()) === (preGender === null || preGender === void 0 ? void 0 : preGender.toLowerCase());
        })) === null || _data$genderList$find === void 0 ? void 0 : _data$genderList$find.code);
      }

      if (!(values !== null && values !== void 0 && (_values$proposerDetai2 = values.proposerDetails) !== null && _values$proposerDetai2 !== void 0 && _values$proposerDetai2.eiaRequired)) {
        setFieldValue("proposerDetails.eiaRequired", 'No');
      }

      if (isConfigImd && !(values !== null && values !== void 0 && (_values$proposerDetai3 = values.proposerDetails) !== null && _values$proposerDetai3 !== void 0 && _values$proposerDetai3.ciuType)) {
        setFieldValue("proposerDetailsMeta.ciuType", 'Other Bank CRN');
        setKotakBankCrnSelected(false);
      }
    },
    onError: function onError(err) {
      setAlerts([{
        header: 'No dropdown details',
        id: 1,
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, err.message)),
        type: 'error',
        timeout: null,
        disableClose: false
      }]);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }),
      loading = _useQuery.loading,
      dropDownDetails = _useQuery.data;

  var onPermAddrLookup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, setFieldValue) {
      var _reactiveVarData$prop7;

      var queryOutput, _yield$queryOutput, _data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop7 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop7 === void 0 ? void 0 : _reactiveVarData$prop7.length) > 0)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (val.toString().length !== 6 || !val.toString().match(/^[0-9]+$/)) {
                _context.next = 26;
                break;
              }

              queryOutput = fetchQuery({
                query: PINCODE_LOOKUP,
                variables: {
                  filter: {
                    pincode: val
                  }
                }
              });
              _context.prev = 4;
              setAlerts([]);
              setLoadingPermCustAddr(true);
              _context.next = 9;
              return queryOutput;

            case 9:
              _yield$queryOutput = _context.sent;
              _data = _yield$queryOutput.data;
              setLoadingPermCustAddr(false);
              setFieldValue('proposerDetails.permCityTownVillage', _data.pincodeInfo.city);
              setFieldValue('proposerDetails.permDistrict', _data.pincodeInfo.district);
              setFieldValue('proposerDetails.permState', _data.pincodeInfo.state);

              if (values.proposerDetails.permCommAddressYN) {
                setFieldValue('proposerDetails.commCityTownVillage', _data.pincodeInfo.city);
                setFieldValue('proposerDetails.commDistrict', _data.pincodeInfo.district);
                setFieldValue('proposerDetails.commState', _data.pincodeInfo.state);
              }

              _context.next = 26;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](4);
              setAlerts([{
                header: 'Address fetch failed',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, _context.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              setLoadingPermCustAddr(false);
              setFieldValue('proposerDetails.permCityTownVillage', '');
              setFieldValue('proposerDetails.permDistrict', '');
              setFieldValue('proposerDetails.permState', '');
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 18]]);
    }));

    return function onPermAddrLookup(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onCommAddrLookup = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val, setFieldValue) {
      var _reactiveVarData$prop8;

      var queryOutput, _yield$queryOutput2, _data2;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop8 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop8 === void 0 ? void 0 : _reactiveVarData$prop8.length) > 0)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (val.toString().length !== 6 || !val.toString().match(/^[0-9]+$/)) {
                _context2.next = 25;
                break;
              }

              queryOutput = fetchQuery({
                query: PINCODE_LOOKUP,
                variables: {
                  filter: {
                    pincode: val
                  }
                }
              });
              _context2.prev = 4;
              setAlerts([]);
              setLoadingCommCustAddr(true);
              _context2.next = 9;
              return queryOutput;

            case 9:
              _yield$queryOutput2 = _context2.sent;
              _data2 = _yield$queryOutput2.data;
              setLoadingCommCustAddr(false);
              setFieldValue('proposerDetails.commCityTownVillage', _data2.pincodeInfo.city);
              setFieldValue('proposerDetails.commDistrict', _data2.pincodeInfo.district);
              setFieldValue('proposerDetails.commState', _data2.pincodeInfo.state);
              _context2.next = 25;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](4);
              setAlerts([{
                header: 'Address fetch failed',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, _context2.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              setLoadingCommCustAddr(false);
              setFieldValue('proposerDetails.commCityTownVillage', '');
              setFieldValue('proposerDetails.commDistrict', '');
              setFieldValue('proposerDetails.commState', '');
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 17]]);
    }));

    return function onCommAddrLookup(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  var salutationList = dropDownDetails.salutationList,
      genderList = dropDownDetails.genderList;
      dropDownDetails.idProofTypeList;
      var maritalStatusList = dropDownDetails.maritalStatusList,
      nationalityList = dropDownDetails.nationalityList,
      occupationList = dropDownDetails.occupationList,
      eiaRequired = dropDownDetails.eiaRequired,
      ciuTypeList = dropDownDetails.ciuTypeList; // console.log("individual : roleName",sessionStorage?.getItem('roleName')?.toString()?.toLowerCase());

  var data = [reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prop9 = reactiveVarData.proposerDetails) !== null && _reactiveVarData$prop9 !== void 0 && _reactiveVarData$prop9.id ? {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary break-all"
    }, [reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop10 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop10 === void 0 ? void 0 : _reactiveVarData$prop10.title, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop11 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop11 === void 0 ? void 0 : _reactiveVarData$prop11.fullName].filter(function (n) {
      return n;
    }).join(' '), ',', repeat === 1 ? /*#__PURE__*/React.createElement("br", null) : /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0"), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposerDetails.id, ' ', /*#__PURE__*/React.createElement("span", {
      className: "break-normal"
    }, "- Update or confirm details")),
    grid_type: 'data',
    grid_data: [{
      label: 'Customer Number',
      text: reformData(reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop12 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop12 === void 0 ? void 0 : _reactiveVarData$prop12.id, '')
    } // {
    //   label: 'CRN',
    //   text: reformData(
    //     reactiveVarData?.proposerDetailsMeta?.crn,
    //     '',
    //   ),
    // },
    ]
  } : null, {
    title: '',
    grid_type: 'input',
    grid_data: [{
      type: 'select',
      label: ((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : (_sessionStorage$getIt = _sessionStorage.getItem('roleName')) === null || _sessionStorage$getIt === void 0 ? void 0 : (_sessionStorage$getIt2 = _sessionStorage$getIt.toString()) === null || _sessionStorage$getIt2 === void 0 ? void 0 : _sessionStorage$getIt2.toLowerCase()) === 'bancsassurance' || ((_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : (_sessionStorage2$getI = _sessionStorage2.getItem('roleName')) === null || _sessionStorage2$getI === void 0 ? void 0 : (_sessionStorage2$getI2 = _sessionStorage2$getI.toString()) === null || _sessionStorage2$getI2 === void 0 ? void 0 : _sessionStorage2$getI2.toLowerCase()) === 'corporate agent' || isConfigImd ? /*#__PURE__*/React.createElement("div", null, "CIU Type ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")) : /*#__PURE__*/React.createElement("div", null, " CIU Type "),
      name: 'proposerDetailsMeta.ciuType',
      data: ciuTypeList && (ciuTypeList === null || ciuTypeList === void 0 ? void 0 : ciuTypeList.length) > 0 ? _toConsumableArray(ciuTypeList === null || ciuTypeList === void 0 ? void 0 : ciuTypeList.map(function (data) {
        return {
          label: data.code,
          value: data.value
        };
      })) : [],
      onDataChange: function onDataChange(val, setFieldValue) {
        setFieldValue("proposerDetailsMeta.ciuType", val);
        setFieldValue("proposerDetailsMeta.crn", '');
        setCRNVerified(null);

        if (val === 'Kotak Bank CRN Number') {
          setKotakBankCrnSelected(true); //  console.log("inside on data change KotakBankCrnSelected : ",KotakBankCrnSelected);
        } else {
          setKotakBankCrnSelected(false);
        }
      },
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0
    }, {
      type: 'text',
      label: ((_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : (_sessionStorage3$getI = _sessionStorage3.getItem('roleName')) === null || _sessionStorage3$getI === void 0 ? void 0 : (_sessionStorage3$getI2 = _sessionStorage3$getI.toString()) === null || _sessionStorage3$getI2 === void 0 ? void 0 : _sessionStorage3$getI2.toLowerCase()) === 'bancsassurance' || ((_sessionStorage4 = sessionStorage) === null || _sessionStorage4 === void 0 ? void 0 : (_sessionStorage4$getI = _sessionStorage4.getItem('roleName')) === null || _sessionStorage4$getI === void 0 ? void 0 : (_sessionStorage4$getI2 = _sessionStorage4$getI.toString()) === null || _sessionStorage4$getI2 === void 0 ? void 0 : _sessionStorage4$getI2.toLowerCase()) === 'corporate agent' || isConfigImd ? /*#__PURE__*/React.createElement("div", null, "CRN Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")) : /*#__PURE__*/React.createElement("div", null, " CRN Number"),
      maxlength: 25,
      name: 'proposerDetailsMeta.crn',
      onDataChange: function onDataChange(val, _) {
        setCRNVerified(null);
      },
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop13 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop13 === void 0 ? void 0 : _reactiveVarData$prop13.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'render',
      component: function component() {
        var _reactiveVarData$prop14;

        return CRNVerified ? /*#__PURE__*/React.createElement(Text, {
          className: "mt-8 w-28 h-11 flex justify-end items-center -ml-2",
          severity: "success",
          type: "large"
        }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faCheck,
          className: "mr-2"
        }), /*#__PURE__*/React.createElement(Text, {
          type: "title"
        }, "Verified")) : /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "small",
          className: "mt-8 w-40 h-11 flex justify-end",
          disabled: !KotakBankCrnSelected || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop14 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop14 === void 0 ? void 0 : _reactiveVarData$prop14.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
          onClick: /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_) {
              var _values$proposerDetai4, _values$proposerDetai5, _values$proposerDetai6, _values$proposerDetai7;

              var _values$proposerDetai8, verifycrnNumber, _yield$verifycrnNumbe, verificationData;

              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!(values !== null && values !== void 0 && (_values$proposerDetai4 = values.proposerDetailsMeta) !== null && _values$proposerDetai4 !== void 0 && _values$proposerDetai4.crn && (values === null || values === void 0 ? void 0 : (_values$proposerDetai5 = values.proposerDetailsMeta) === null || _values$proposerDetai5 === void 0 ? void 0 : (_values$proposerDetai6 = _values$proposerDetai5.crn) === null || _values$proposerDetai6 === void 0 ? void 0 : _values$proposerDetai6.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$proposerDetai7 = values.proposerDetailsMeta) === null || _values$proposerDetai7 === void 0 ? void 0 : _values$proposerDetai7.ciuType) === 'Kotak Bank CRN Number')) {
                        _context3.next = 20;
                        break;
                      }

                      _context3.prev = 1;
                      verifycrnNumber = fetchQuery({
                        query: VERIFY_CRN_NUMBER,
                        variables: {
                          crnNumber: values === null || values === void 0 ? void 0 : (_values$proposerDetai8 = values.proposerDetailsMeta) === null || _values$proposerDetai8 === void 0 ? void 0 : _values$proposerDetai8.crn
                        }
                      });
                      setAlerts([]);
                      setLoadingCRN(true); //setLoadingTransaction(true);

                      _context3.next = 7;
                      return verifycrnNumber;

                    case 7:
                      _yield$verifycrnNumbe = _context3.sent;
                      verificationData = _yield$verifycrnNumbe.data;
                      setLoadingCRN(false);

                      if (verificationData.verifyCRNNumber.isVerified) {
                        setCRNVerified(true);
                        setFieldValue("proposerDetailsMeta.isCRNVerified", true);
                      } else {
                        setCRNVerified(false);
                        setFieldValue("proposerDetailsMeta.isCRNVerified", false);
                        setAlerts([{
                          header: 'Transaction ID verification failure',
                          id: Date.now(),
                          content: /*#__PURE__*/React.createElement("div", {
                            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                          }, /*#__PURE__*/React.createElement("span", null, "Please check the CRN Number entered, either CRN is not valid or is not KYC Compliant or not authorize for insurance transaction.")),
                          type: 'error',
                          timeout: null,
                          disableClose: false
                        }]);
                        window.scrollTo({
                          top: 0,
                          behavior: 'smooth'
                        });
                      }

                      _context3.next = 20;
                      break;

                    case 13:
                      _context3.prev = 13;
                      _context3.t0 = _context3["catch"](1);
                      setCRNVerified(false);
                      setLoadingCRN(false);
                      setFieldValue("proposerDetailsMeta.isCRNVerified", false);
                      setAlerts([{
                        header: 'Transaction ID verification failure',
                        id: Date.now(),
                        content: /*#__PURE__*/React.createElement("div", {
                          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                        }, /*#__PURE__*/React.createElement("span", null, "Please check the CRN Number entered, either CRN is not valid or is not KYC Compliant or not authorize for insurance transaction.")),
                        type: 'error',
                        timeout: null,
                        disableClose: false
                      }]);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });

                    case 20:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[1, 13]]);
            }));

            return function (_x5) {
              return _ref4.apply(this, arguments);
            };
          }(),
          flat: true //CRNVerified,loadingVerifyCRN
          ,
          iconPre: /*#__PURE__*/React.createElement("div", {
            className: "text-base"
          }, loadingVerifyCRN ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faSpinner,
            spin: true,
            className: 'mx-2'
          }) : CRNVerified === false ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faExclamationTriangle,
            className: 'mx-2'
          }) : CRNVerified ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faCheck,
            className: 'mx-2'
          }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faSearch,
            className: 'mx-2'
          }))
        }, loadingVerifyCRN ? /*#__PURE__*/React.createElement("span", {
          className: "text-base"
        }, "Verifying") : CRNVerified === false ? /*#__PURE__*/React.createElement("span", {
          className: "text-base"
        }, "Not Verified") : CRNVerified ? /*#__PURE__*/React.createElement("span", {
          className: "text-base"
        }, "Verified") : /*#__PURE__*/React.createElement("span", {
          className: "text-base"
        }, "Verify"));
      }
    }]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Personal Details"),
    grid_type: 'input',
    grid_data: [{
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "Title ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.title',
      searchable: true,
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop15 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop15 === void 0 ? void 0 : _reactiveVarData$prop15.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onDataChange: function onDataChange(val, setFieldValue) {
        if (getDomainData(salutationList, val, 'value', 'code')) {
          setFieldValue("proposerDetails.title", getDomainData(salutationList, val, 'value', 'code'));
        }
      },
      data: salutationList && (salutationList === null || salutationList === void 0 ? void 0 : salutationList.length) > 0 ? (salutationList === null || salutationList === void 0 ? void 0 : (_salutationList$filte = salutationList.filter(function (salutation) {
        var _salutation$gender, _values$proposerDetai9, _values$proposerDetai10;

        return (salutation === null || salutation === void 0 ? void 0 : (_salutation$gender = salutation.gender) === null || _salutation$gender === void 0 ? void 0 : _salutation$gender.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$proposerDetai9 = values.proposerDetails) === null || _values$proposerDetai9 === void 0 ? void 0 : (_values$proposerDetai10 = _values$proposerDetai9.gender) === null || _values$proposerDetai10 === void 0 ? void 0 : _values$proposerDetai10.toLowerCase());
      })) === null || _salutationList$filte === void 0 ? void 0 : _salutationList$filte.length) === 0 ? salutationList === null || salutationList === void 0 ? void 0 : salutationList.map(function (salutation) {
        return {
          label: salutation !== null && salutation !== void 0 && salutation.value ? salutation === null || salutation === void 0 ? void 0 : salutation.value : '',
          value: salutation !== null && salutation !== void 0 && salutation.code ? salutation === null || salutation === void 0 ? void 0 : salutation.code : ''
        };
      }) : salutationList === null || salutationList === void 0 ? void 0 : (_salutationList$filte2 = salutationList.filter(function (salutation) {
        var _salutation$gender2, _values$proposerDetai11, _values$proposerDetai12;

        return (salutation === null || salutation === void 0 ? void 0 : (_salutation$gender2 = salutation.gender) === null || _salutation$gender2 === void 0 ? void 0 : _salutation$gender2.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$proposerDetai11 = values.proposerDetails) === null || _values$proposerDetai11 === void 0 ? void 0 : (_values$proposerDetai12 = _values$proposerDetai11.gender) === null || _values$proposerDetai12 === void 0 ? void 0 : _values$proposerDetai12.toLowerCase()) || !(salutation !== null && salutation !== void 0 && salutation.gender);
      })) === null || _salutationList$filte2 === void 0 ? void 0 : _salutationList$filte2.map(function (salutation) {
        return {
          label: salutation !== null && salutation !== void 0 && salutation.value ? salutation === null || salutation === void 0 ? void 0 : salutation.value : '',
          value: salutation !== null && salutation !== void 0 && salutation.code ? salutation === null || salutation === void 0 ? void 0 : salutation.code : ''
        };
      }) : []
    }, {
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "Gender ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.gender',
      data: genderList ? _toConsumableArray(genderList.map(function (gender) {
        return {
          label: gender.value ? gender.value : '',
          value: gender.code ? gender.code : ''
        };
      })) : [],
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop16 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop16 === void 0 ? void 0 : _reactiveVarData$prop16.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) // ||
      // (preGender !== undefined &&
      //   preGender !== null &&
      //   preGender !== ''),

    }, {
      type: 'date',
      maxdate: moment().subtract(18, 'years').subtract(1, 'days').format('DD/MM/YYYY'),
      label: /*#__PURE__*/React.createElement("div", null, "Date Of Birth ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.proposerDOB',
      //disabled: reactiveVarData?.proposalNumber.length > 0,
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop17 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop17 === void 0 ? void 0 : _reactiveVarData$prop17.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop18 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop18 === void 0 ? void 0 : _reactiveVarData$prop18.id) !== null && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop19 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop19 === void 0 ? void 0 : _reactiveVarData$prop19.id.length) > 0
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "First Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.firstName',
      // disabled: reactiveVarData?.proposalNumber.length > 0,
      // disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop20 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop20 === void 0 ? void 0 : _reactiveVarData$prop20.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop21 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop21 === void 0 ? void 0 : _reactiveVarData$prop21.id) !== null && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop22 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop22 === void 0 ? void 0 : _reactiveVarData$prop22.id.length) > 0,
      onKeyDown: function onKeyDown(evt) {
        var _evt$target, _evt$target$value, _evt$target$value$toS, _evt$target2, _evt$target2$value, _evt$target2$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target = evt.target) !== null && _evt$target !== void 0 && (_evt$target$value = _evt$target.value) !== null && _evt$target$value !== void 0 && (_evt$target$value$toS = _evt$target$value.toString()) !== null && _evt$target$value$toS !== void 0 && _evt$target$value$toS.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target2 = evt.target) === null || _evt$target2 === void 0 ? void 0 : (_evt$target2$value = _evt$target2.value) === null || _evt$target2$value === void 0 ? void 0 : (_evt$target2$value$to = _evt$target2$value.toString()) === null || _evt$target2$value$to === void 0 ? void 0 : _evt$target2$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      },
      onDataChange: function onDataChange(val, setFieldValue) {
        var _values$proposerDetai13, _values$proposerDetai14, _values$proposerDetai15, _values$proposerDetai16, _values$proposerDetai17, _values$proposerDetai18, _values$proposerDetai19, _values$proposerDetai20;

        setFieldValue("proposerDetails.fullName", // [
        //   val?.trim(),
        //   values?.proposerDetails?.middleName?.trim(),
        //   values?.proposerDetails?.lastName?.trim(),
        // ]
        //   .filter((n) => n)
        //   .join(' '),
        values !== null && values !== void 0 && (_values$proposerDetai13 = values.proposerDetails) !== null && _values$proposerDetai13 !== void 0 && _values$proposerDetai13.middleName ? "".concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai14 = values.proposerDetails) === null || _values$proposerDetai14 === void 0 ? void 0 : _values$proposerDetai14.firstName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai15 = values.proposerDetails) === null || _values$proposerDetai15 === void 0 ? void 0 : _values$proposerDetai15.middleName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai16 = values.proposerDetails) === null || _values$proposerDetai16 === void 0 ? void 0 : _values$proposerDetai16.lastName) : values !== null && values !== void 0 && (_values$proposerDetai17 = values.proposerDetails) !== null && _values$proposerDetai17 !== void 0 && _values$proposerDetai17.lastName ? "".concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai18 = values.proposerDetails) === null || _values$proposerDetai18 === void 0 ? void 0 : _values$proposerDetai18.firstName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai19 = values.proposerDetails) === null || _values$proposerDetai19 === void 0 ? void 0 : _values$proposerDetai19.lastName) : values === null || values === void 0 ? void 0 : (_values$proposerDetai20 = values.proposerDetails) === null || _values$proposerDetai20 === void 0 ? void 0 : _values$proposerDetai20.firstName);
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Middle Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.middleName',
      //disabled: reactiveVarData?.proposalNumber.length > 0,
      // disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop23 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop23 === void 0 ? void 0 : _reactiveVarData$prop23.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop24 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop24 === void 0 ? void 0 : _reactiveVarData$prop24.id) !== null && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop25 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop25 === void 0 ? void 0 : _reactiveVarData$prop25.id.length) > 0,
      onKeyDown: function onKeyDown(evt) {
        var _evt$target3, _evt$target3$value, _evt$target3$value$to, _evt$target4, _evt$target4$value, _evt$target4$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target3 = evt.target) !== null && _evt$target3 !== void 0 && (_evt$target3$value = _evt$target3.value) !== null && _evt$target3$value !== void 0 && (_evt$target3$value$to = _evt$target3$value.toString()) !== null && _evt$target3$value$to !== void 0 && _evt$target3$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target4 = evt.target) === null || _evt$target4 === void 0 ? void 0 : (_evt$target4$value = _evt$target4.value) === null || _evt$target4$value === void 0 ? void 0 : (_evt$target4$value$to = _evt$target4$value.toString()) === null || _evt$target4$value$to === void 0 ? void 0 : _evt$target4$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      },
      onDataChange: function onDataChange(val, setFieldValue) {
        var _values$proposerDetai21, _values$proposerDetai22, _values$proposerDetai23, _values$proposerDetai24, _values$proposerDetai25, _values$proposerDetai26, _values$proposerDetai27, _values$proposerDetai28;

        setFieldValue("proposerDetails.fullName", // [
        //   values?.proposerDetails?.firstName?.trim(),
        //   val?.trim(),
        //   values?.proposerDetails?.lastName?.trim(),
        // ]
        //   .filter((n) => n)
        //   .join(' '),
        values !== null && values !== void 0 && (_values$proposerDetai21 = values.proposerDetails) !== null && _values$proposerDetai21 !== void 0 && _values$proposerDetai21.middleName ? "".concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai22 = values.proposerDetails) === null || _values$proposerDetai22 === void 0 ? void 0 : _values$proposerDetai22.firstName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai23 = values.proposerDetails) === null || _values$proposerDetai23 === void 0 ? void 0 : _values$proposerDetai23.middleName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai24 = values.proposerDetails) === null || _values$proposerDetai24 === void 0 ? void 0 : _values$proposerDetai24.lastName) : values !== null && values !== void 0 && (_values$proposerDetai25 = values.proposerDetails) !== null && _values$proposerDetai25 !== void 0 && _values$proposerDetai25.lastName ? "".concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai26 = values.proposerDetails) === null || _values$proposerDetai26 === void 0 ? void 0 : _values$proposerDetai26.firstName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai27 = values.proposerDetails) === null || _values$proposerDetai27 === void 0 ? void 0 : _values$proposerDetai27.lastName) : values === null || values === void 0 ? void 0 : (_values$proposerDetai28 = values.proposerDetails) === null || _values$proposerDetai28 === void 0 ? void 0 : _values$proposerDetai28.firstName);
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Last Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.lastName',
      //disabled: reactiveVarData?.proposalNumber.length > 0,
      //disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop26 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop26 === void 0 ? void 0 : _reactiveVarData$prop26.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop27 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop27 === void 0 ? void 0 : _reactiveVarData$prop27.id) !== null && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop28 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop28 === void 0 ? void 0 : _reactiveVarData$prop28.id.length) > 0,
      onKeyDown: function onKeyDown(evt) {
        var _evt$target5, _evt$target5$value, _evt$target5$value$to, _evt$target6, _evt$target6$value, _evt$target6$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target5 = evt.target) !== null && _evt$target5 !== void 0 && (_evt$target5$value = _evt$target5.value) !== null && _evt$target5$value !== void 0 && (_evt$target5$value$to = _evt$target5$value.toString()) !== null && _evt$target5$value$to !== void 0 && _evt$target5$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target6 = evt.target) === null || _evt$target6 === void 0 ? void 0 : (_evt$target6$value = _evt$target6.value) === null || _evt$target6$value === void 0 ? void 0 : (_evt$target6$value$to = _evt$target6$value.toString()) === null || _evt$target6$value$to === void 0 ? void 0 : _evt$target6$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      },
      onDataChange: function onDataChange(val, setFieldValue) {
        var _values$proposerDetai29, _values$proposerDetai30, _values$proposerDetai31, _values$proposerDetai32, _values$proposerDetai33, _values$proposerDetai34, _values$proposerDetai35, _values$proposerDetai36;

        setFieldValue("proposerDetails.fullName", // [
        //   values?.proposerDetails?.firstName?.trim(),
        //   values?.proposerDetails?.middleName?.trim(),
        //   val?.trim(),
        // ]
        //   .filter((n) => n)
        //   .join(' '),
        values !== null && values !== void 0 && (_values$proposerDetai29 = values.proposerDetails) !== null && _values$proposerDetai29 !== void 0 && _values$proposerDetai29.middleName ? "".concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai30 = values.proposerDetails) === null || _values$proposerDetai30 === void 0 ? void 0 : _values$proposerDetai30.firstName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai31 = values.proposerDetails) === null || _values$proposerDetai31 === void 0 ? void 0 : _values$proposerDetai31.middleName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai32 = values.proposerDetails) === null || _values$proposerDetai32 === void 0 ? void 0 : _values$proposerDetai32.lastName) : values !== null && values !== void 0 && (_values$proposerDetai33 = values.proposerDetails) !== null && _values$proposerDetai33 !== void 0 && _values$proposerDetai33.lastName ? "".concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai34 = values.proposerDetails) === null || _values$proposerDetai34 === void 0 ? void 0 : _values$proposerDetai34.firstName, " ").concat(values === null || values === void 0 ? void 0 : (_values$proposerDetai35 = values.proposerDetails) === null || _values$proposerDetai35 === void 0 ? void 0 : _values$proposerDetai35.lastName) : values === null || values === void 0 ? void 0 : (_values$proposerDetai36 = values.proposerDetails) === null || _values$proposerDetai36 === void 0 ? void 0 : _values$proposerDetai36.firstName);
      }
    }, {
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "Marital Status ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.maritalStatus',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop29 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop29 === void 0 ? void 0 : _reactiveVarData$prop29.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      data: maritalStatusList ? _toConsumableArray(maritalStatusList.map(function (maritalStatus) {
        return {
          label: maritalStatus.value ? maritalStatus.value : '',
          value: maritalStatus.code ? maritalStatus.code : ''
        };
      })) : []
    }, {
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "Nationality ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.nationality',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop30 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop30 === void 0 ? void 0 : _reactiveVarData$prop30.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      data: nationalityList ? _toConsumableArray(nationalityList.map(function (nationality) {
        return {
          label: nationality.value ? nationality.value : '',
          value: nationality.code ? nationality.code : ''
        };
      })) : []
    }, {
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "Occupation ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      data: occupationList ? _toConsumableArray(occupationList.map(function (occupation) {
        return {
          label: occupation.value ? occupation.value : '',
          value: occupation.code ? occupation.code : ''
        };
      })) : [],
      name: "proposerDetails.occupation",
      /// disabled: buyHealthPolicy?.proposalNumber.length > 0,
      onDataChange: function onDataChange(val, setFieldValue) {
        setFieldValue("proposerDetails.otherOccupation", '');
      }
    }, {
      type: 'text',
      maxLength: 100,
      disabled: values.proposerDetails.occupation !== getDomainData(occupationList, 'Others', 'value', 'code'),
      //|| buyHealthPolicy?.proposalNumber.length > 0,
      label: /*#__PURE__*/React.createElement("div", null, "If Others Occupation, please specify"),
      name: "proposerDetails.otherOccupation"
    },
    /*SADivya - CR P2_233 -KYC*/
    {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Mother's Maiden Name"),
      maxLength: 30,
      name: 'proposerDetails.motherMaidenName',
      //disabled: reactiveVarData?.proposalNumber.length > 0,
      // disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop31 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop31 === void 0 ? void 0 : _reactiveVarData$prop31.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onKeyDown: function onKeyDown(evt) {
        var _evt$target7, _evt$target7$value, _evt$target7$value$to, _evt$target8, _evt$target8$value, _evt$target8$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target7 = evt.target) !== null && _evt$target7 !== void 0 && (_evt$target7$value = _evt$target7.value) !== null && _evt$target7$value !== void 0 && (_evt$target7$value$to = _evt$target7$value.toString()) !== null && _evt$target7$value$to !== void 0 && _evt$target7$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target8 = evt.target) === null || _evt$target8 === void 0 ? void 0 : (_evt$target8$value = _evt$target8.value) === null || _evt$target8$value === void 0 ? void 0 : (_evt$target8$value$to = _evt$target8$value.toString()) === null || _evt$target8$value$to === void 0 ? void 0 : _evt$target8$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "CKYC ID Number"),
      maxLength: 14,
      name: 'proposerDetails.ckycIdNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop32 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop32 === void 0 ? void 0 : _reactiveVarData$prop32.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onKeyDown: function onKeyDown(evt) {
        if ((evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }, {
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "EIA Required"),
      name: 'proposerDetails.eiaRequired',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop33 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop33 === void 0 ? void 0 : _reactiveVarData$prop33.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      data: (eiaRequired === null || eiaRequired === void 0 ? void 0 : eiaRequired.length) > 0 ? _toConsumableArray(eiaRequired.map(function (eiaReq) {
        return {
          label: eiaReq.value ? eiaReq.value : '',
          value: eiaReq.code ? eiaReq.code : ''
        };
      })) : [{
        label: 'Yes',
        value: 'Yes'
      }, {
        label: 'No',
        value: 'No'
      }, {
        label: 'Already exist',
        value: 'Already exist'
      }],
      onDataChange: function onDataChange(val, setFieldValue) {
        if ((val === null || val === void 0 ? void 0 : val.toLowerCase()) === 'yes' || (val === null || val === void 0 ? void 0 : val.toLowerCase()) === 'no') {
          setFieldValue("proposerDetails.eiaNumber", '');
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "EIA Number"),
      maxLength: 15,
      name: 'proposerDetails.eiaNumber',
      //disabled: reactiveVarData?.proposalNumber.length > 0,
      // disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
      disabled: ((_values$proposerDetai37 = values.proposerDetails) === null || _values$proposerDetai37 === void 0 ? void 0 : (_values$proposerDetai38 = _values$proposerDetai37.eiaRequired) === null || _values$proposerDetai38 === void 0 ? void 0 : _values$proposerDetai38.toLowerCase()) === 'no' || ((_values$proposerDetai39 = values.proposerDetails) === null || _values$proposerDetai39 === void 0 ? void 0 : (_values$proposerDetai40 = _values$proposerDetai39.eiaRequired) === null || _values$proposerDetai40 === void 0 ? void 0 : _values$proposerDetai40.toLowerCase()) === 'yes' || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop34 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop34 === void 0 ? void 0 : _reactiveVarData$prop34.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onKeyDown: function onKeyDown(evt) {
        var _evt$target9, _evt$target9$value, _evt$target9$value$to;

        if ((evt === null || evt === void 0 ? void 0 : (_evt$target9 = evt.target) === null || _evt$target9 === void 0 ? void 0 : (_evt$target9$value = _evt$target9.value) === null || _evt$target9$value === void 0 ? void 0 : (_evt$target9$value$to = _evt$target9$value.toString()) === null || _evt$target9$value$to === void 0 ? void 0 : _evt$target9$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }
    /*EADivya - CR P2_233 KYC*/
    ]
  },
  /*SU Divya : CR P2_233 KYC :Hide Identification Details*/
  // {
  //   title: (
  //     <span className="text-primary">Identification Details<span className="text-base">(Either PAN Card Number OR ID Proof Number is Mandatory)</span></span>
  //   ),
  //   grid_type: 'input',
  //   grid_data: [
  //     {
  //       type: 'select',
  //       label: (
  //         <div>
  //           ID Proof Type <Text severity="error">*</Text>
  //         </div>
  //       ),
  //       name: 'proposerDetails.idProofType',
  //       disabled: reactiveVarData?.proposalNumber.length > 0,
  //       data: idProofTypeList
  //         ? [
  //             ...idProofTypeList.map((idProofType) => {
  //               return {
  //                 label: idProofType.value ? idProofType.value : '',
  //                 value: idProofType.code ? idProofType.code : '',
  //               };
  //             }),
  //           ]
  //         : [],
  //     },
  //     {
  //       type: 'text',
  //       label: (
  //         <div>
  //           ID Proof Number <Text severity="error"></Text>
  //         </div>
  //       ),
  //       name: 'proposerDetails.idProofNumber',
  //       className: 'uppercase',
  //       disabled: reactiveVarData?.proposalNumber.length > 0,
  //     },
  //   ],
  // },

  /*EU Divya : CR P2_233 KYC: Hide Identification Details*/
  {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Internal Employee"),
    grid_type: 'input',
    grid_data: [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "If internal employee, then provide the employee number", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$quot = reactiveVarData.quoteData) === null || _reactiveVarData$quot === void 0 ? void 0 : (_reactiveVarData$quot2 = _reactiveVarData$quot.isExistingEmployee) === null || _reactiveVarData$quot2 === void 0 ? void 0 : _reactiveVarData$quot2.toLowerCase()) === 'yes' ? '*' : '')),
      name: 'proposerDetails.employeeNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop35 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop35 === void 0 ? void 0 : _reactiveVarData$prop35.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Tax Identification Details"),
    grid_type: 'input',
    grid_data: (_ref5 = [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "GST Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.gstNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop36 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop36 === void 0 ? void 0 : _reactiveVarData$prop36.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      className: 'uppercase'
    }, {}, {}, {
      type: 'radiogroup',
      label: /*#__PURE__*/React.createElement(Text, null, "Do you have PAN No ? ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      //  className:'flex',
      className: 'items-baseline space-x-2 mt-4',
      flow: 'row',
      name: 'proposerDetails.isPanAvailable',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop37 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop37 === void 0 ? void 0 : _reactiveVarData$prop37.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop38 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop38 === void 0 ? void 0 : (_reactiveVarData$prop39 = _reactiveVarData$prop38.isKYCVerified) === null || _reactiveVarData$prop39 === void 0 ? void 0 : _reactiveVarData$prop39.toString()) === 'true',
      data: [{
        label: 'Yes',
        value: 'Yes'
      }, {
        label: 'No',
        value: 'No'
      }],
      onRadioChange: function onRadioChange(val) {
        if (val === 'No') {
          setFieldValue("proposerDetails.panNumber", '');
        } else if (val === 'Yes') {
          setFieldValue("proposerDetails.form60", false);
        }
      }
    }, (values === null || values === void 0 ? void 0 : (_values$proposerDetai41 = values.proposerDetails.isPanAvailable) === null || _values$proposerDetai41 === void 0 ? void 0 : (_values$proposerDetai42 = _values$proposerDetai41.toString()) === null || _values$proposerDetai42 === void 0 ? void 0 : _values$proposerDetai42.toLowerCase()) === 'yes' ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "PAN Card Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.panNumber',
      className: 'uppercase',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop40 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop40 === void 0 ? void 0 : _reactiveVarData$prop40.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop41 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop41 === void 0 ? void 0 : (_reactiveVarData$prop42 = _reactiveVarData$prop41.isKYCVerified) === null || _reactiveVarData$prop42 === void 0 ? void 0 : _reactiveVarData$prop42.toString()) === 'true'
    } : null, (values === null || values === void 0 ? void 0 : (_values$proposerDetai43 = values.proposerDetails.isPanAvailable) === null || _values$proposerDetai43 === void 0 ? void 0 : (_values$proposerDetai44 = _values$proposerDetai43.toString()) === null || _values$proposerDetai44 === void 0 ? void 0 : _values$proposerDetai44.toLowerCase()) === 'no' ? {
      type: 'checkbox',
      label: /*#__PURE__*/React.createElement("div", null, "Form 60 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.form60',
      className: 'mt-4',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop43 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop43 === void 0 ? void 0 : _reactiveVarData$prop43.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop44 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop44 === void 0 ? void 0 : (_reactiveVarData$prop45 = _reactiveVarData$prop44.isKYCVerified) === null || _reactiveVarData$prop45 === void 0 ? void 0 : _reactiveVarData$prop45.toString()) === 'true'
    } : null]) === null || _ref5 === void 0 ? void 0 : _ref5.filter(function (d) {
      return d;
    })
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Permanent Address Details"),
    grid_type: 'input',
    grid_data: [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permAddressLine1',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop46 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop46 === void 0 ? void 0 : _reactiveVarData$prop46.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop47 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop47 === void 0 ? void 0 : (_reactiveVarData$prop48 = _reactiveVarData$prop47.id) === null || _reactiveVarData$prop48 === void 0 ? void 0 : _reactiveVarData$prop48.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine1', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.permAddressLine2',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop49 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop49 === void 0 ? void 0 : _reactiveVarData$prop49.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop50 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop50 === void 0 ? void 0 : (_reactiveVarData$prop51 = _reactiveVarData$prop50.id) === null || _reactiveVarData$prop51 === void 0 ? void 0 : _reactiveVarData$prop51.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine2', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 3 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permAddressLine3',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop52 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop52 === void 0 ? void 0 : _reactiveVarData$prop52.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop53 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop53 === void 0 ? void 0 : (_reactiveVarData$prop54 = _reactiveVarData$prop53.id) === null || _reactiveVarData$prop54 === void 0 ? void 0 : _reactiveVarData$prop54.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine3', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Landmark ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permLandmark',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop55 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop55 === void 0 ? void 0 : _reactiveVarData$prop55.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop56 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop56 === void 0 ? void 0 : (_reactiveVarData$prop57 = _reactiveVarData$prop56.id) === null || _reactiveVarData$prop57 === void 0 ? void 0 : _reactiveVarData$prop57.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commLandmark', val);
        }
      }
    }, {
      type: 'input-lookup',
      size: 'large',
      loading: loadingPermCustAddr,
      onLookup: onPermAddrLookup,
      label: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permPincode',
      disabled: loadingPermCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop58 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop58 === void 0 ? void 0 : _reactiveVarData$prop58.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop59 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop59 === void 0 ? void 0 : (_reactiveVarData$prop60 = _reactiveVarData$prop59.id) === null || _reactiveVarData$prop60 === void 0 ? void 0 : _reactiveVarData$prop60.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        setFieldValue('proposerDetails.permCityTownVillage', '');
        setFieldValue('proposerDetails.permState', '');
        setFieldValue('proposerDetails.permDistrict', '');

        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commPincode', val);
          setFieldValue('proposerDetails.commCityTownVillage', '');
          setFieldValue('proposerDetails.commState', '');
          setFieldValue('proposerDetails.commDistrict', '');
        }
      },
      onKeyDown: function onKeyDown(e) {
        var _ref6, _e$key, _e$key$toString;

        if (!e.key.match(/^[0-9]+$/) && !((_ref6 = ['arrowleft', 'arrowright', 'backspace']) !== null && _ref6 !== void 0 && _ref6.includes(e === null || e === void 0 ? void 0 : (_e$key = e.key) === null || _e$key === void 0 ? void 0 : (_e$key$toString = _e$key.toString()) === null || _e$key$toString === void 0 ? void 0 : _e$key$toString.toLowerCase()))) {
          e.preventDefault();
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "City/Town/Village ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permCityTownVillage',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permDistrict',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permState',
      disabled: true
    }]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Communication Address"),
    grid_data: values.proposerDetails.permCommAddressYN ? [{
      type: 'checkbox',
      name: 'proposerDetails.permCommAddressYN',
      disabled: loadingPermCustAddr || loadingCommCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop61 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop61 === void 0 ? void 0 : _reactiveVarData$prop61.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      label: 'Communication address same as permanent address',
      colSpan: repeat,
      onDataChange: function onDataChange(_, setFieldValue) {
        setFieldValue('proposerDetails.commAddressLine1', '');
        setFieldValue('proposerDetails.commAddressLine2', '');
        setFieldValue('proposerDetails.commAddressLine3', '');
        setFieldValue('proposerDetails.commLandmark', '');
        setFieldValue('proposerDetails.commPincode', '');
        setFieldValue('proposerDetails.commCityTownVillage', '');
        setFieldValue('proposerDetails.commDistrict', '');
        setFieldValue('proposerDetails.commState', '');
      }
    }] : [{
      type: 'checkbox',
      name: 'proposerDetails.permCommAddressYN',
      label: 'Communication address same as permanent address',
      disabled: loadingPermCustAddr || loadingCommCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop62 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop62 === void 0 ? void 0 : _reactiveVarData$prop62.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      colSpan: repeat,
      onDataChange: function onDataChange(_, setFieldValue) {
        setFieldValue('proposerDetails.commAddressLine1', values.proposerDetails.permAddressLine1);
        setFieldValue('proposerDetails.commAddressLine2', values.proposerDetails.permAddressLine2);
        setFieldValue('proposerDetails.commAddressLine3', values.proposerDetails.permAddressLine3);
        setFieldValue('proposerDetails.commLandmark', values.proposerDetails.permLandmark);
        setFieldValue('proposerDetails.commPincode', values.proposerDetails.permPincode);
        setFieldValue('proposerDetails.commCityTownVillage', values.proposerDetails.permCityTownVillage);
        setFieldValue('proposerDetails.commDistrict', values.proposerDetails.permDistrict);
        setFieldValue('proposerDetails.commState', values.proposerDetails.permState);
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commAddressLine1',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop63 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop63 === void 0 ? void 0 : _reactiveVarData$prop63.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.commAddressLine2',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop64 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop64 === void 0 ? void 0 : _reactiveVarData$prop64.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 3 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commAddressLine3',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop65 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop65 === void 0 ? void 0 : _reactiveVarData$prop65.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Landmark ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commLandmark',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop66 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop66 === void 0 ? void 0 : _reactiveVarData$prop66.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'input-lookup',
      size: 'large',
      loading: loadingCommCustAddr,
      onLookup: onCommAddrLookup,
      label: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commPincode',
      disabled: loadingCommCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop67 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop67 === void 0 ? void 0 : _reactiveVarData$prop67.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onDataChange: function onDataChange(_, setFieldValue) {
        setFieldValue('proposerDetails.commCityTownVillage', '');
        setFieldValue('proposerDetails.commState', '');
        setFieldValue('proposerDetails.commDistrict', '');
      },
      onKeyDown: function onKeyDown(e) {
        var _ref7, _e$key2, _e$key2$toString;

        if (!e.key.match(/^[0-9]+$/) && !((_ref7 = ['arrowleft', 'arrowright', 'backspace']) !== null && _ref7 !== void 0 && _ref7.includes(e === null || e === void 0 ? void 0 : (_e$key2 = e.key) === null || _e$key2 === void 0 ? void 0 : (_e$key2$toString = _e$key2.toString()) === null || _e$key2$toString === void 0 ? void 0 : _e$key2$toString.toLowerCase()))) {
          e.preventDefault();
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "City/Town/Village ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commCityTownVillage',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commDistrict',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commState',
      disabled: true
    }]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Contact Details"),
    grid_data: [{
      type: 'text',
      maxLength: 10,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Mobile Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.mobileNo',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop68 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop68 === void 0 ? void 0 : _reactiveVarData$prop68.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'email',
      label: /*#__PURE__*/React.createElement("div", null, "Email Id ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.emailID',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop69 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop69 === void 0 ? void 0 : _reactiveVarData$prop69.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }]
  }].filter(function (d) {
    return d !== null;
  });
  var other_props = {
    flow: 'cols',
    repeat: repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    textType: 'normal',
    nullData: function nullData() {
      return /*#__PURE__*/React.createElement(Text, {
        severity: "neutral"
      }, "Not Captured");
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
    data: data
  }, other_props))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  })));
}

function OrganisationCustomerForm(_ref) {
  var _reactiveVarData$prop3, _reactiveVarData$prop4, _reactiveVarData$prop5, _reactiveVarData$prop6, _reactiveVarData$prop7, _reactiveVarData$prop8, _reactiveVarData$prop9, _reactiveVarData$prop10, _reactiveVarData$prop11, _reactiveVarData$prop12, _reactiveVarData$prop13, _reactiveVarData$prop14, _reactiveVarData$prop15, _reactiveVarData$prop16, _reactiveVarData$prop17;

  var reactiveVarData = _ref.reactiveVarData;
  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      alerts = _useState2[0],
      setAlerts = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loadingPermCustAddr = _useState4[0],
      setLoadingPermCustAddr = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loadingCommCustAddr = _useState6[0],
      setLoadingCommCustAddr = _useState6[1];

  var reformData = function reformData(val, returnType, isString) {
    return val && val.toString().trim() !== '' ? isString === undefined || isString === true ? "".concat(val) : val : returnType;
  };

  var fetchQuery = useFetchQuery();

  var _useQuery = useQuery(CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onError: function onError(err) {
      setAlerts([{
        header: 'No dropdown details',
        id: 1,
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, err.message)),
        type: 'error',
        timeout: null,
        disableClose: false
      }]);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }),
      loading = _useQuery.loading,
      dropDownDetails = _useQuery.data;

  var onPermAddrLookup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, setFieldValue) {
      var _reactiveVarData$prop;

      var queryOutput, _yield$queryOutput, _data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop === void 0 ? void 0 : _reactiveVarData$prop.length) > 0)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (val.toString().length !== 6 || !val.toString().match(/^[0-9]+$/)) {
                _context.next = 26;
                break;
              }

              queryOutput = fetchQuery({
                query: PINCODE_LOOKUP,
                variables: {
                  filter: {
                    pincode: val
                  }
                }
              });
              _context.prev = 4;
              setAlerts([]);
              setLoadingPermCustAddr(true);
              _context.next = 9;
              return queryOutput;

            case 9:
              _yield$queryOutput = _context.sent;
              _data = _yield$queryOutput.data;
              setLoadingPermCustAddr(false);
              setFieldValue('proposerDetails.permCityTownVillage', _data.pincodeInfo.city);
              setFieldValue('proposerDetails.permDistrict', _data.pincodeInfo.district);
              setFieldValue('proposerDetails.permState', _data.pincodeInfo.state);

              if (values.proposerDetails.permCommAddressYN) {
                setFieldValue('proposerDetails.commCityTownVillage', _data.pincodeInfo.city);
                setFieldValue('proposerDetails.commDistrict', _data.pincodeInfo.district);
                setFieldValue('proposerDetails.commState', _data.pincodeInfo.state);
              }

              _context.next = 26;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](4);
              setAlerts([{
                header: 'Address fetch failed',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, _context.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              setLoadingPermCustAddr(false);
              setFieldValue('proposerDetails.permCityTownVillage', '');
              setFieldValue('proposerDetails.permDistrict', '');
              setFieldValue('proposerDetails.permState', '');
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 18]]);
    }));

    return function onPermAddrLookup(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onCommAddrLookup = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val, setFieldValue) {
      var _reactiveVarData$prop2;

      var queryOutput, _yield$queryOutput2, _data2;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!((reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop2 = reactiveVarData.proposalNumber) === null || _reactiveVarData$prop2 === void 0 ? void 0 : _reactiveVarData$prop2.length) > 0)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (val.toString().length !== 6 || !val.toString().match(/^[0-9]+$/)) {
                _context2.next = 25;
                break;
              }

              queryOutput = fetchQuery({
                query: PINCODE_LOOKUP,
                variables: {
                  filter: {
                    pincode: val
                  }
                }
              });
              _context2.prev = 4;
              setAlerts([]);
              setLoadingCommCustAddr(true);
              _context2.next = 9;
              return queryOutput;

            case 9:
              _yield$queryOutput2 = _context2.sent;
              _data2 = _yield$queryOutput2.data;
              setLoadingCommCustAddr(false);
              setFieldValue('proposerDetails.commCityTownVillage', _data2.pincodeInfo.city);
              setFieldValue('proposerDetails.commDistrict', _data2.pincodeInfo.district);
              setFieldValue('proposerDetails.commState', _data2.pincodeInfo.state);
              _context2.next = 25;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](4);
              setAlerts([{
                header: 'Address fetch failed',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, _context2.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              setLoadingCommCustAddr(false);
              setFieldValue('proposerDetails.commCityTownVillage', '');
              setFieldValue('proposerDetails.commDistrict', '');
              setFieldValue('proposerDetails.commState', '');
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 17]]);
    }));

    return function onCommAddrLookup(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  var organisationList = dropDownDetails.organisationList;
  var data = [reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prop3 = reactiveVarData.proposerDetails) !== null && _reactiveVarData$prop3 !== void 0 && _reactiveVarData$prop3.id ? {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary break-all"
    }, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop4 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop4 === void 0 ? void 0 : _reactiveVarData$prop4.orgName, ',', repeat === 1 ? /*#__PURE__*/React.createElement("br", null) : /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0"), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop5 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop5 === void 0 ? void 0 : _reactiveVarData$prop5.id, ' ', /*#__PURE__*/React.createElement("span", {
      className: "break-normal"
    }, "- Update or confirm details")),
    grid_type: 'data',
    grid_data: [{
      label: 'Customer Number',
      text: reformData(reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop6 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop6 === void 0 ? void 0 : _reactiveVarData$prop6.id, '')
    }, {
      label: 'CRN',
      text: reformData(reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop7 = reactiveVarData.proposerDetailsMeta) === null || _reactiveVarData$prop7 === void 0 ? void 0 : _reactiveVarData$prop7.crn, '')
    }]
  } : null, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Organisation Details"),
    grid_type: 'input',
    grid_data: [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.orgName',
      onKeyDown: function onKeyDown(evt) {
        var _evt$target, _evt$target$value, _evt$target$value$toS, _evt$target2, _evt$target2$value, _evt$target2$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target = evt.target) !== null && _evt$target !== void 0 && (_evt$target$value = _evt$target.value) !== null && _evt$target$value !== void 0 && (_evt$target$value$toS = _evt$target$value.toString()) !== null && _evt$target$value$toS !== void 0 && _evt$target$value$toS.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target2 = evt.target) === null || _evt$target2 === void 0 ? void 0 : (_evt$target2$value = _evt$target2.value) === null || _evt$target2$value === void 0 ? void 0 : (_evt$target2$value$to = _evt$target2$value.toString()) === null || _evt$target2$value$to === void 0 ? void 0 : _evt$target2$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      },
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Type ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.orgType',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      data: organisationList ? _toConsumableArray(organisationList.map(function (orgType) {
        return {
          label: orgType.value ? orgType.value : '',
          value: orgType.code ? orgType.code : ''
        };
      })) : []
    },
    /**P2_928 -  Contact Person Name  as non-Mandatory*/
    {
      type: 'text',
      maxLength: 40,
      label: /*#__PURE__*/React.createElement("div", null, "Contact Person Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.contactName',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Tax Identification Details"),
    grid_type: 'input',
    grid_data: [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Registration Number"),
      name: 'proposerDetails.regNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "TAN Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.tanNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      className: 'uppercase'
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "GST Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.gstNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      className: 'uppercase'
    },
    /*SADivya - CR P2_233 :KYC*/
    {
      type: 'text',
      maxLength: 20,
      label: /*#__PURE__*/React.createElement("div", null, "Udyog Aadhaar Number"),
      name: 'proposerDetails.udyogAadhaarNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onKeyDown: function onKeyDown(e) {
        var _evt;

        if (!e.key.match(/^[0-9]+$/) || ((_evt = evt) === null || _evt === void 0 ? void 0 : _evt.key) === ' ') {
          e.preventDefault();
        }
      }
    }, {
      type: 'text',
      maxLength: 21,
      label: /*#__PURE__*/React.createElement("div", null, "Certificate of Incorporation ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.certificateOfInCorporation',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "CKYC ID Number"),
      maxLength: 14,
      name: 'proposerDetails.ckycIdNumber',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onKeyDown: function onKeyDown(evt) {
        if ((evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    },
    /*EADivya - CR P2_233: KYC*/

    /**SADivya : CR P2_498 - PAN Mandatory */
    {
      type: 'date',
      label: /*#__PURE__*/React.createElement("div", null, "Date Of incorporation ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.dateOfIncorporation',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "PAN Card Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.panNumber',
      className: 'uppercase',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }
    /**SADivya : CR P2_498 - PAN Mandatory */
    ]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Permanent Address Details"),
    grid_type: 'input',
    grid_data: [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permAddressLine1',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop8 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop8 === void 0 ? void 0 : (_reactiveVarData$prop9 = _reactiveVarData$prop8.id) === null || _reactiveVarData$prop9 === void 0 ? void 0 : _reactiveVarData$prop9.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine1', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.permAddressLine2',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop10 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop10 === void 0 ? void 0 : (_reactiveVarData$prop11 = _reactiveVarData$prop10.id) === null || _reactiveVarData$prop11 === void 0 ? void 0 : _reactiveVarData$prop11.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine2', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 3 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permAddressLine3',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop12 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop12 === void 0 ? void 0 : (_reactiveVarData$prop13 = _reactiveVarData$prop12.id) === null || _reactiveVarData$prop13 === void 0 ? void 0 : _reactiveVarData$prop13.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine3', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Landmark ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permLandmark',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop14 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop14 === void 0 ? void 0 : (_reactiveVarData$prop15 = _reactiveVarData$prop14.id) === null || _reactiveVarData$prop15 === void 0 ? void 0 : _reactiveVarData$prop15.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commLandmark', val);
        }
      }
    }, {
      type: 'input-lookup',
      size: 'large',
      loading: loadingPermCustAddr,
      onLookup: onPermAddrLookup,
      label: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permPincode',
      disabled: loadingPermCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify) || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop16 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop16 === void 0 ? void 0 : (_reactiveVarData$prop17 = _reactiveVarData$prop16.id) === null || _reactiveVarData$prop17 === void 0 ? void 0 : _reactiveVarData$prop17.length) > 0,
      //SADivya : Cr P2_233:KYC
      onDataChange: function onDataChange(val, setFieldValue) {
        setFieldValue('proposerDetails.permCityTownVillage', '');
        setFieldValue('proposerDetails.permState', '');
        setFieldValue('proposerDetails.permDistrict', '');

        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commPincode', val);
          setFieldValue('proposerDetails.commCityTownVillage', '');
          setFieldValue('proposerDetails.commState', '');
          setFieldValue('proposerDetails.commDistrict', '');
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "City/Town/Village ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permCityTownVillage',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permDistrict',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.permState',
      disabled: true
    }]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Communication Address"),
    grid_data: values.proposerDetails.permCommAddressYN ? [{
      type: 'checkbox',
      name: 'proposerDetails.permCommAddressYN',
      disabled: loadingPermCustAddr || loadingCommCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      label: 'Communication address same as permanent address',
      colSpan: repeat,
      onDataChange: function onDataChange(_, setFieldValue) {
        setFieldValue('proposerDetails.commAddressLine1', '');
        setFieldValue('proposerDetails.commAddressLine2', '');
        setFieldValue('proposerDetails.commAddressLine3', '');
        setFieldValue('proposerDetails.commLandmark', '');
        setFieldValue('proposerDetails.commPincode', '');
        setFieldValue('proposerDetails.commCityTownVillage', '');
        setFieldValue('proposerDetails.commDistrict', '');
        setFieldValue('proposerDetails.commState', '');
      }
    }] : [{
      type: 'checkbox',
      name: 'proposerDetails.permCommAddressYN',
      disabled: loadingPermCustAddr || loadingCommCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      label: 'Communication address same as permanent address',
      colSpan: repeat,
      onDataChange: function onDataChange(_, setFieldValue) {
        setFieldValue('proposerDetails.commAddressLine1', values.proposerDetails.permAddressLine1);
        setFieldValue('proposerDetails.commAddressLine2', values.proposerDetails.permAddressLine2);
        setFieldValue('proposerDetails.commAddressLine3', values.proposerDetails.permAddressLine3);
        setFieldValue('proposerDetails.commLandmark', values.proposerDetails.permLandmark);
        setFieldValue('proposerDetails.commPincode', values.proposerDetails.permPincode);
        setFieldValue('proposerDetails.commCityTownVillage', values.proposerDetails.permCityTownVillage);
        setFieldValue('proposerDetails.commDistrict', values.proposerDetails.permDistrict);
        setFieldValue('proposerDetails.commState', values.proposerDetails.permState);
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commAddressLine1',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.commAddressLine2',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 3 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commAddressLine3',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Landmark ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commLandmark',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'input-lookup',
      size: 'large',
      loading: loadingCommCustAddr,
      onLookup: onCommAddrLookup,
      label: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commPincode',
      disabled: loadingCommCustAddr || (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify),
      onDataChange: function onDataChange(_, setFieldValue) {
        setFieldValue('proposerDetails.commCityTownVillage', '');
        setFieldValue('proposerDetails.commState', '');
        setFieldValue('proposerDetails.commDistrict', '');
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "City/Town/Village ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commCityTownVillage',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commDistrict',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.commState',
      disabled: true
    }]
  }, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, "Contact Details"),
    grid_data: [{
      type: 'number',
      min: 0,
      label: /*#__PURE__*/React.createElement("div", null, "Telephone Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.phoneNo',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      maxLength: 10,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Mobile Number", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.mobileNo',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'number',
      min: 0,
      label: /*#__PURE__*/React.createElement("div", null, "FAX Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.faxNo',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'number',
      min: 0,
      label: /*#__PURE__*/React.createElement("div", null, "Alternative Telephone Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.altPhoneNo',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'text',
      maxLength: 10,
      label: /*#__PURE__*/React.createElement("div", null, "Alternative Mobile Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.altMobileNo',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }, {
      type: 'email',
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Email Id ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'proposerDetails.emailID',
      disabled: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber.length) > 0 && !(reactiveVarData !== null && reactiveVarData !== void 0 && reactiveVarData.isProposalModify)
    }]
  }].filter(function (d) {
    return d !== null;
  });
  var other_props = {
    flow: 'cols',
    repeat: repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    textType: 'normal',
    nullData: function nullData() {
      return /*#__PURE__*/React.createElement(Text, {
        severity: "neutral"
      }, "Not Captured");
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
    data: data
  }, other_props))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  })));
}

export { IndividualCustomerForm as I, OrganisationCustomerForm as O };
